import QueryString from "qs";
import dynamic from "next/dynamic";
import { GetServerSideProps, NextPage } from "next";
const TechnologyPage = dynamic(
  () => import("@/Components/pages/TechnologyPage")
);
const GhostPage = dynamic(() => import("@/Components/pages/GhostPage"));

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59"
    );
  }
  const slug = ctx?.params?.slug;

  let apiRes = null;
  let apiResData = null;
  let isNew = false;
  const query = QueryString.stringify(
    {
      filters: {
        slug: {
          $eq: slug,
        },
      },
      populate: "deep, 8",
    },
    {
      encodeValuesOnly: false,
    }
  );
  apiRes = await fetch(`${baseUrl}technologies?${decodeURIComponent(query)}`);
  apiResData = await apiRes.json();
  isNew = apiResData?.data[0]?.attributes?.design === "new";
  if (apiResData?.data?.length === 0) return { notFound: true };

  return {
    props: {
      apiResData,
      isNew,
      slug,
    },
  };
};

interface Props {
  apiResData: any;
  isNew: boolean;
  slug: string;
}

const Technology: NextPage<Props> = ({ apiResData, slug }) => {
  return (
    <div id="root">
      <div>
        {apiResData?.data?.[0]?.attributes?.template === "ghost-page" ? (
          <GhostPage slug={slug} data={apiResData} />
        ) : (
          <TechnologyPage slug={slug} data={apiResData} />
        )}
      </div>
    </div>
  );
};
export default Technology;
